import { cn } from '@/lib/cn';

export function Switch({ checked, onChange, disabled, label, size = 'md' }: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label: string;
  size?: 'sm' | 'md';
}) {
  const sm = size === 'sm';
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={(e) => { e.stopPropagation(); onChange(!checked); }}
      className={cn(
        'relative inline-flex shrink-0 items-center rounded-full transition-colors duration-150',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 disabled:opacity-50',
        sm ? 'h-[18px] w-8' : 'h-[22px] w-10',
        checked ? 'bg-accent' : 'bg-line-strong',
      )}
    >
      <span
        className={cn(
          'inline-block rounded-full bg-white shadow transition-transform duration-150',
          sm ? 'h-[14px] w-[14px]' : 'h-[18px] w-[18px]',
          checked ? (sm ? 'translate-x-[16px]' : 'translate-x-[20px]') : 'translate-x-[2px]',
        )}
      />
    </button>
  );
}
